import type { ScreenContext } from './types.ts';
import { createMoodSlider } from '@/components/mood-slider.ts';
import { createContinueButton, setButtonLoading } from '@/components/continue-button.ts';
import { addMoodCheckin } from '@/api/operations.ts';

export function renderSilenceCheckin(container: HTMLElement, ctx: ScreenContext) {
  const { state, dispatch } = ctx;
  const startedAt = performance.now();

  container.innerHTML = `
    <div class="card space-y-6">
      <div>
        <p class="text-sm uppercase tracking-wide text-gray-500">After breathing pause ${state.silenceIndex}</p>
        <h2 class="text-2xl font-semibold text-gray-900">How do you feel after the pause?</h2>
      </div>
      <div id="slider-slot"></div>
      <div id="action-slot"></div>
    </div>
  `;

  const slider = createMoodSlider('silence-checkin', 'Stress level after silence', 5, true);
  container.querySelector('#slider-slot')?.appendChild(slider.root);

  const btn = createContinueButton('Continue');
  container.querySelector('#action-slot')?.appendChild(btn);

  btn.addEventListener('click', async () => {
    setButtonLoading(btn, true, 'Continue', 'Saving...');
    const mood = slider.getValue();
    const durationMs = Math.round(performance.now() - startedAt);
    dispatch({ type: 'ADD_SILENCE_CHECKIN', payload: { mood } });

    if (state.sessionId) {
      try {
        await addMoodCheckin({
          sessionId: state.sessionId,
          checkinType: 'silence',
          sequenceIndex: state.silenceCheckins.length + 1,
          clipIndex: null,
          silenceIndex: state.silenceIndex,
          moodValue: mood,
          durationMs,
        });
      } catch (error) {
        console.error('Failed to persist silence check-in', error);
      }
    }

    dispatch({ type: 'NEXT_PHASE' });
    setButtonLoading(btn, false, 'Continue');
  });
}
